module.exports = __webpack_public_path__ + "media/images/icon__questionmark--rb-light-gray@3x-0cb6638f82b837989e530d8207038020.png";